import PayMaestroLogo from '@/assets/svg/PayMaestroLogo.svg'
import PayQrLogo from '@/assets/svg/PayQrLogo.svg'

import {
  PayMethods,
  PayMethodsOption,
  ReceiptMethodsOption
} from './BillsPayDrawer.types'

export const payMethodsOptions: PayMethodsOption[] = [
  {
    key: PayMethods.Acquiring,
    name: 'Банковская карта',
    description: '',
    icon: <PayMaestroLogo />
  },
  {
    key: PayMethods.Qr,
    name: 'QR-код для оплаты',
    description: 'Оплата в приложении вашего банка',
    icon: <PayQrLogo />
  }
]

export const receiptMethodsOptions: ReceiptMethodsOption[] = [
  {
    key: 'email',
    name: 'По почте'
  }
]
